import React, { useState, useEffect,useContext } from "react";
import "./index.css";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import patientAvatar from "../avatar.png";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import { Link, useLocation, useNavigate } from "react-router-dom";
import StarRatings from "react-star-ratings";
import TextField from "@mui/material/TextField";
import visaCard1 from "./images/visaCard1.PNG";
import visaCard2 from "./images/visaCard2.PNG";
import visaCard3 from "./images/visaCard3.PNG";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useFormik } from "formik";
import axios from "axios";
import UserContext from "../../../context/userContext";
import useUser from "../../../context/user/useUser";

const url = "http://localhost:5050/api/v1/users/";
const url2 = "deedmed";

const AddAppointment3 = () => {
  const navigate = useNavigate();
  const [doctorData, setDoctorData] = useState([]);
  const location = useLocation();
  const path = location.pathname.split("/")[3];
  // let userValue = useContext(UserContext);
  // let { user_id, user_type } = userValue;
  const { settings } = useUser();
  const user_id = settings.userId;

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get(url + path);
      setDoctorData(result.data);
    };
    fetchData();
  }, [path]);

  const formik = useFormik({
    initialValues: {
      cardName: "",
      cardNumber: "",
      expireDate: "",
      cvv: "",
    },
    onSubmit: (values) => {
      navigate("thank-you");
      localStorage.setItem("card name", values.cardName);
      localStorage.setItem("card number", values.cardNumber);
      localStorage.setItem("expire date", values.expireDate);
      localStorage.setItem("cvv", values.cvv);
    },
  });

  const addAppointment = async () => {
    const response = await axios.post(
      `http://localhost:5050/api/v1/appointments/create_appointment`,
      {
        doctor_id: path,
        patient_id: user_id,
        patient_details_id: 0,
        patient_name:user_id,
        profile:"",
        appointment_title: "Fever consultation",
        appointment_reason: localStorage.getItem("purpose"),
        appointment_time: localStorage.getItem("Time"),
        appointment_date: localStorage.getItem("Date"),
        appointment_type:localStorage.getItem("type"),
        appointment_status: 0,
        attachment_1: "",
        attachment_2: "",
        attachment_3: "",
        attachment_4: "",
        attachment_5: "",
        attachment_6: "",
        message: localStorage.getItem("message"),
        medical_details: localStorage.getItem("medical details"),
        amount_submitted: 0,
      }
    );
    localStorage.removeItem("Time");
    localStorage.removeItem("Date");
    localStorage.removeItem("message");
    localStorage.removeItem("medical details");
    localStorage.removeItem("purpose");

  };

  return (
    <>
      <div className="addAppointmentMain">
        <div className="addAppointmentMainHeading">
          <div onClick={() => navigate(-1)}>
            <ArrowCircleLeftOutlinedIcon
              className="headingIcon"
              fontSize="large"
            />
          </div>
          <h3>Add Appointment</h3>
        </div>
        <div>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              "& > :not(style)": {
                ml: 2,
                mr: 2,
                pl: 4,
                pb: 2,
                pr: 4,
                width: "100%",
                height: "auto",
                background:
                  "linear-gradient(90.22deg, #0536E3 -19.45%, #00E9ED 142.36%)",
                color: "#ffffff",
              },
            }}
          >
            <Paper elevation={0}>
              <Grid container>
                <Grid item lg={7} md={6} xs={12}>
                  <Stack direction="row" spacing={2}>
                    <Avatar
                      alt="Patient Avatar"
                      src={patientAvatar}
                      className="addAppointmentProfileAvatar"
                    />
                    <div className="addAppointmentProfileAvatarName">
                      <h2>
                        {doctorData[0] && doctorData[0].first_name}{" "}
                        {doctorData[0] && doctorData[0].last_name}
                      </h2>
                      <p>
                        {/* Specialist{" "} */}
                        {doctorData[0] && doctorData[0].area_of_interest}
                      </p>
                      <div>
                        <StarRatings
                          rating={4}
                          starDimension="18px"
                          starRatedColor="yellow"
                          numberOfStars={5}
                          starSpacing="1px"
                        />
                      </div>
                    </div>
                  </Stack>
                </Grid>
                <Grid
                  item
                  lg={5}
                  md={6}
                  xs={12}
                  mt={-3}
                  className="appointmentPriceGrid"
                >
                  <p>LKR{doctorData[0] && doctorData[0].hourly_rate}.00</p>
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </div>

        <div className="docterProfileScroll">
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              "& > :not(style)": {
                ml: 2,
                mr: 2,
                pl: 4,
                pb: 2,
                pr: 4,
                width: "100%",
                height: "auto",
              },
            }}
          >
            {/* info1 info2 edit icon css from doctor profile component */}
            <Paper elevation={0}>
              <h2>Make Payment</h2>
              <Grid container>
                <Grid item lg={6} md={10} xs={12}>
                  <div className="visaCardImg">
                    <img alt="visa card" src={visaCard1} width={220} />
                    <img
                      alt="visa card"
                      src={visaCard2}
                      width={210}
                      height={110}
                    />
                    <img
                      alt="visa card"
                      src={visaCard3}
                      width={210}
                      height={110}
                    />
                  </div>
                  <Button variant="text" className="addNewCardBtn">
                    Add New Card{" "}
                    <span>
                      <AddCircleIcon fontSize="small" />
                    </span>
                  </Button>
                </Grid>
              </Grid>
              <form onSubmit={formik.handleSubmit}>
                <Grid container>
                  <Grid item lg={3} md={6} xs={12}>
                    <div className="info1">
                      <div>
                        <h6>Name on Card</h6>
                        <TextField
                          variant="standard"
                          size="small"
                          placeholder="Type"
                          className="messageTextField"
                          id="cardName"
                          onChange={formik.handleChange}
                          value={formik.values.cardName}
                          InputProps={{
                            disableUnderline: true,
                          }}
                          required
                        />
                      </div>
                    </div>
                    <div className="info1 info2">
                      <div>
                        <h6>Card Number</h6>
                        <TextField
                          variant="standard"
                          size="small"
                          placeholder="Type"
                          className="messageTextField"
                          id="cardNumber"
                          onChange={formik.handleChange}
                          value={formik.values.cardNumber}
                          InputProps={{
                            disableUnderline: true,
                          }}
                          required
                        />
                      </div>
                    </div>
                    <div className="paymentInfo">
                      <div className="info1 info2 paymentDetail">
                        <div>
                          <h6>Expiration Date</h6>
                          <TextField
                            variant="standard"
                            size="small"
                            placeholder="Type"
                            className="messageTextField"
                            id="expireDate"
                            onChange={formik.handleChange}
                            value={formik.values.expireDate}
                            InputProps={{
                              disableUnderline: true,
                            }}
                            required
                          />
                        </div>
                      </div>
                      <div className="info1 info2 paymentDetail">
                        <div>
                          <h6>CVV</h6>
                          <TextField
                            variant="standard"
                            size="small"
                            placeholder="Type"
                            className="messageTextField"
                            id="cvv"
                            onChange={formik.handleChange}
                            value={formik.values.cvv}
                            InputProps={{
                              disableUnderline: true,
                            }}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
                <Button variant="contained" className="payBtn" type="submit" onClick={addAppointment}>
                  Pay LKR250.00
                </Button>
              </form>
            </Paper>
          </Box>
        </div>
      </div>
    </>
  );
};
export default AddAppointment3;
